export const TOSS_PAYMENT_CLIENT_KEY = {
  TEST: "test_ck_XZYkKL4MrjLe47zEk09B30zJwlEW",
  LIVE: "live_ck_QbgMGZzorzbgO47Gw9vlrl5E1em4",
};
